<template>
  <div class="alert alert-gray alert-dismissible border-0 fade show fw-semibold mx-n4 px-4 mx-xl-0 px-xl-3" role="alert" v-if="showDismissibleAlert">
    <p
      v-if="
        isSuccessAlert() ||
        (!isWarningAlert() && !isInfoAlert() && !isDangerAlert())
      ">
      {{ product.name }} op je {{ $t("wishlist") }}
    </p>
    <a
      v-if="
        isSuccessAlert() ||
        (!isWarningAlert() && !isInfoAlert() && !isDangerAlert())
      "
      href="#"
      class="btn btn-outline-gray mt-4 px-4"
      >{{ $t("wishlist") }}
    </a>
    <button type="button" class="btn-close" data-dismiss="alert" aria-label="Close"></button>
  </div>
</template>

<script>
export default {
  name: "ProductAlert",
  props: ["product", "showDismissibleAlert"],
  components: {
  },
  data() {
    return {};
  },
  methods: {
    isInfoAlert() {
      return this.product.alertVariant === "info";
    },
    isDangerAlert() {
      return this.product.alertVariant === "danger";
    },
    isWarningAlert() {
      return this.product.alertVariant === "warning";
    },
    isSuccessAlert() {
      return this.product.alertVariant === "success";
    },
  },
};
</script>
